import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    templateUrl: './cities.component.html'
})
export class CitiesComponent implements OnInit {
    ManikCitiesList: any[] = [];
    private DomainName: string;
    constructor(private dialogRef: MatDialogRef<CitiesComponent>) {
        dialogRef.disableClose = true;
        this.DomainName = location.hostname.replace("www.", "");
    }

    ngOnInit() {
        this.ManikCitiesList = JSON.parse(localStorage.getItem(this.DomainName + "_ManikCity")); //this.dialogRef.componentInstance.ManikCitiesList;
    }

    FilterCities(SearchTerm: string) {
        this.ManikCitiesList = JSON.parse(localStorage.getItem(this.DomainName + "_ManikCity")).filter(item => item.CityName.toLowerCase().includes(SearchTerm.toLowerCase()));
    }

    SetCity(CityID: number) {
        this.dialogRef.close({
            CityID: CityID
        });
    }

    closeDialog() {
        this.dialogRef.close();
    }
}
